import { ArrowForward, ChatBubbleOutline } from "@mui/icons-material";
import React, { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthorModal } from "./AuthorModal";

const AuthorAvatar = ({ src, name }) => {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className="w-7 h-7 rounded-full object-cover shrink-0"
        style={{ border: "2px solid #ffc000" }}
      />
    );
  }
  return (
    <svg
      viewBox="0 0 32 32"
      className="w-7 h-7 rounded-full shrink-0"
      style={{ background: "rgba(255,192,0,0.12)" }}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="12" r="5" fill="#ffc000" opacity="0.8" />
      <path
        d="M6 26c0-5.523 4.477-10 10-10s10 4.477 10 10"
        stroke="#ffc000"
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.8"
      />
    </svg>
  );
};

export const ResCard = (props) => {
  const navigate = useNavigate();
  const [authorModal, setAuthorModal] = useState(false);

  return (
    <Fragment>
      <AuthorModal open={authorModal} onClose={() => setAuthorModal(false)} authorName={props.iconText} />
      <div
        className="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
        style={{ border: "1px solid rgba(255,192,0,0.2)" }}
      >
        {/* Gold top accent bar */}
        <div
          className="h-1 w-full"
          style={{
            background: "linear-gradient(90deg, #ffc000, #ffe066, #ffc000)",
          }}
        />

        {/* Image */}
        <div className="relative overflow-hidden h-48">
          <img
            src={props.image}
            alt={props.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          {/* Gold gradient overlay */}
          <div
            className="absolute bottom-0 left-0 right-0 h-12"
            style={{
              background:
                "linear-gradient(to top, rgba(255,192,0,0.4), transparent)",
            }}
          />
          {/* Date badge */}
          <div
            className="absolute bottom-3 left-3 flex items-center gap-1.5 rounded-full px-3 py-1 shadow"
            style={{ background: "#ffc000" }}
          >
            <svg
              viewBox="0 0 16 16"
              className="w-3 h-3 fill-white shrink-0"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M5 1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v1h16V4a2 2 0 0 0-2-2h-1V1a1 1 0 0 0-2 0v1H5V1zm-3 6v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H2z" />
            </svg>
            <span className="font-abel text-xs text-white font-semibold whitespace-nowrap">
              {props.date}
            </span>
          </div>
        </div>

        {/* Body */}
        <div className="p-4 flex flex-col gap-3">
          {/* Title */}
          <h3
            className="font-aref font-bold text-base md:text-lg leading-snug line-clamp-2 transition-colors duration-200"
            style={{ color: "#1a1a2e" }}
          >
            {props.title}
          </h3>

          {/* Phrase */}
          <p className="font-abel text-gray-500 text-sm leading-relaxed line-clamp-1">
            {props.phrase}
          </p>

          {/* Divider */}
          <div
            className="h-px w-full"
            style={{
              background: "linear-gradient(90deg, #ffc000 0%, transparent 70%)",
            }}
          />

          {/* Footer */}
          <div className="flex items-center justify-between gap-2">
            <button
              onClick={() => setAuthorModal(true)}
              className="flex items-center gap-2 min-w-0 hover:opacity-70 transition-opacity"
            >
              <AuthorAvatar src={props.authorImg} name={props.iconText} />
              <span className="font-abel text-xs text-gray-500 truncate">
                {props.iconText}
              </span>
            </button>
            <div className="flex items-center gap-3 shrink-0">
              {props.comment > 0 && (
                <div className="flex items-center gap-1 text-gray-400">
                  <ChatBubbleOutline style={{ fontSize: 13 }} />
                  <span className="font-abel text-xs">{props.comment}</span>
                </div>
              )}
              <button
                onClick={() => {
                  navigate(props.path);
                  window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                }}
                className="flex items-center gap-1 font-abel text-xs font-bold hover:gap-2.5 transition-all duration-200 whitespace-nowrap"
                style={{ color: "#ffc000" }}
              >
                {props.btnName}
                <ArrowForward style={{ fontSize: 14 }} />
              </button>
            </div>
          </div>
        </div>

        {/* Gold bottom sweep on hover */}
        <div
          className="h-0.5 w-0 group-hover:w-full transition-all duration-500"
          style={{ background: "#ffc000" }}
        />
      </div>
    </Fragment>
  );
};
